<template>
    <svg class="shape-top-right" viewBox="0 0 1201 499">
        <path
            d="M51.2098 -631.402C139.244 -702.362 210.264 -641.268 255.335 -585.358L681.067 -57.167C726.13 -1.26059 770.745 81.1242 682.713 152.071C594.684 223.031 523.661 161.942 478.592 106.028L52.8591 -422.161C7.79748 -478.068 -36.8164 -560.449 51.2098 -631.402Z"
            class="shape-top-right__sm"
        />
        <path
            d="M317.402 -898.358C456.387 -965.04 531.566 -861.795 573.915 -773.52L973.973 60.3678C1016.31 148.63 1049.79 271.888 910.826 338.561C771.841 405.239 696.658 301.992 654.313 213.717L254.257 -620.167C211.913 -708.431 178.431 -831.691 317.402 -898.358Z"
            class="shape-top-right__md"
        />
        <path
            d="M1273.83 -1315.36C1477.23 -1286.37 1484.11 -1116.28 1465.7 -987.089L1291.76 233.292C1273.35 362.466 1219.2 523.862 1015.82 494.877C812.415 465.884 805.53 295.798 823.948 166.611L997.886 -1053.77C1016.3 -1182.95 1070.44 -1344.35 1273.83 -1315.36Z"
            class="shape-top-right__lg"
        />
    </svg>
</template>

<style lang="scss">
    .shape-top-right {
        overflow: visible;
        width: 100%;
        &__sm {
            fill: var(--joy-color-primary-30);
        }
        &__md {
            fill: var(--joy-color-neutral-20);
        }
        &__lg {
            fill: var(--joy-color-primary-50);
        }
    }
</style>
